iScreenWizard.controller('HomeController', function ($scope, $mdDialog, Dictionary, userService, Gebruikersbericht) {
    $scope.userService = userService;

    $scope.nrUnreadUserMessages = 0;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        Gebruikersbericht.countUnread().then(function (nrUnreadUserMessages) {
            $scope.nrUnreadUserMessages = nrUnreadUserMessages;
        });
    };
});